<template>
  <section v-observe-visibility="isVisible" :class="$style.heroContainer">
    <Wrapper :class="$style.inner">
      <div :class="$style.desc">
        <Breadcrumb
          :category-uid="content.categoryUid"
          :custom-name="content.title[0].text"
        />
        <Title :class="$style.title" :title-params="content.title" />
        <RichText
          :class="$style.description"
          :text-params="content.description"
        />
        <ArrowButton
          v-if="content.cta.text"
          :class="$style.button"
          :href="getFormatedLink(content.cta.link)"
        >
          {{ content.cta.text }}
        </ArrowButton>
        <ul :class="$style.linkList">
          <li v-for="(item, itemIndex) in content.linkList" :key="itemIndex">
            <PLink :link-object="item.link" is-highlight color="bluko">
              {{ item.text }}
            </PLink>
          </li>
        </ul>
      </div>
      <div :class="$style.view">
        <PImage :class="$style.image" :image-object="content.image" />
      </div>
    </Wrapper>
  </section>
</template>

<script>
import PLink from '~/components/PLink'
import Breadcrumb from '~/components/Breadcrumb'
import { getFormatedLink } from '~/mixins/getFormatedLink'
import ArrowButton from '~/components/ArrowButton'

export default {
  name: 'Hero',

  components: {
    PLink,
    Breadcrumb,
    ArrowButton,
  },

  mixins: [getFormatedLink],

  props: {
    content: {
      type: Object,
      required: true,
    },
  },

  methods: {
    isVisible(visible) {
      this.$store.commit('header/SET_HEADER_FIXED', !visible)
    },
  },
}
</script>

<style lang="scss" module>
.heroContainer {
  min-height: 615px;
  margin-top: -64px;
  padding: 64px 40px 46px;

  background-color: #fff4ee;

  @include below(medium) {
    padding: 24px;
    padding-top: 64px;
  }
}

.inner {
  display: flex;
  gap: 90px;
  justify-content: space-between;
  height: 100%;
  padding-top: 56px;

  @include below(large) {
    gap: 40px;
  }
  @include below(medium) {
    flex-direction: column;
    gap: 0;
  }
  @include below(small) {
    padding-top: 24px;
  }
}

.desc {
  width: 50%;
  max-width: 600px;
  @include below(medium) {
    width: 100%;
    max-width: none;
  }
}

.title {
  display: inline;
  margin-top: 16px;

  font-weight: 200;
  font-size: 48px;
  line-height: 59px;

  h1 {
    display: inline;
  }

  @include below(small) {
    font-size: 40px;
    line-height: 56px;
  }
}

.description p {
  margin-top: 16px;

  @include typo-headline;
  color: $gray-700;
}

.button {
  width: 100%;
  margin-top: 40px;

  color: $white;
  font-weight: 500;

  @include above(small) {
    width: auto;
  }
}

.linkList {
  margin-top: 24px;
  padding: 8px 0;

  li {
    padding: 8px 0;
  }
}

.view {
  width: 50%;
  min-height: 430px;
  max-height: 460px;
  margin: 0;
  border-bottom-right-radius: 300px;
  overflow: hidden;

  @include below(medium) {
    width: calc(100vw - 24px);
    max-width: none;
    height: 256px;
    min-height: auto;
    margin-top: 16px;
    margin-right: -24px;
    margin-bottom: -24px;
    border-bottom-right-radius: 0%;
    border-bottom-left-radius: 150px;
  }
}

.image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 80%;
}
</style>
